import { getIcon } from './get_icon';
import { getFaIcon, getLayeredIcon  } from './fontawesome/fontawesome';

const icon = {
	getIcon, getFaIcon, getLayeredIcon
}

export {
	icon
}
